import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! RESPONSIBLE TEAM: team-standalone }}\n\n{{outlet}}",{ moduleName: "embercom/templates/apps/app/standalone/testing.hbs" })